export default __webpack_public_path__ + "static/091-1df4f6fc7d04a99bc3bda90c0f147411.jpg";